module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route sp-cart-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-10 padding-bottom-100 pages-in chart-page checkout-main-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.total_orders_amount != 0) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2 col-xs-12"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('h1', {
    staticClass: "card-title"
  }, [_vm._v("Checkout "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.total_orders_amount))])]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please confirm your orders below")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card billing-details",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('h4', [_vm._v("Billing Details")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Name: " + _vm._s(_vm.payment_details.payment_payer_name))]), _vm._v(" "), _c('p', [_vm._v("Email: " + _vm._s(_vm.payment_details.payment_payer_email))]), _vm._v(" "), _c('p', [_vm._v("Contact Phone No: " + _vm._s(_vm.payment_details.payment_payer_phone))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-details"
  }, _vm._l((_vm.checkout_orders), function(order, index) {
    return _c('div', {
      staticClass: "order-inner"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('h6', [_vm._v("Orders from "), _c('b', [_vm._v(_vm._s(order.order_business))]), _vm._v(" Total: ₦" + _vm._s(order.order_total))]), _vm._v(" "), _vm._l((order.order_items), function(items, index2) {
      return _c('div', [_c('ol', [_vm._v(_vm._s(index2 + 1) + ". " + _vm._s(items.product_name) + " - SKU: " + _vm._s(items.product_item_sku) + " - ₦" + _vm._s(items.product_item_total_price))]), _vm._v(" "), (items.order_delivery_city) ? _c('div', [_c('p', [_vm._v("Delivery Address for " + _vm._s(items.product_name) + ":")]), _vm._v(" "), (items.order_user_delivery_addresses.length != 0) ? _c('div', [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Addresses that match this location; Please select address")]), _vm._v(" "), _vm._l((items.order_user_delivery_addresses), function(address) {
        return _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (items.order_user_delivery_address),
            expression: "items.order_user_delivery_address"
          }],
          attrs: {
            "type": "radio"
          },
          domProps: {
            "value": address.address_id,
            "checked": _vm._q(items.order_user_delivery_address, address.address_id)
          },
          on: {
            "__c": function($event) {
              items.order_user_delivery_address = address.address_id
            }
          }
        }), _vm._v(" " + _vm._s(address.address_address) + " -" + _vm._s(address.address_city)), _c('br')])
      }), _vm._v(" "), _c('br')], 2) : _c('div', {
        staticClass: "contact-form"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (items.order_user_new_delivery_address),
          expression: "items.order_user_new_delivery_address"
        }],
        staticClass: "form-control",
        attrs: {
          "placeholder": "Enter Delivery Address"
        },
        domProps: {
          "value": (items.order_user_new_delivery_address)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            items.order_user_new_delivery_address = $event.target.value
          }
        }
      }, [_vm._v(_vm._s(items.order_user_delivery_address))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Delivery Location: "), _c('b', [_vm._v(_vm._s(items.order_delivery_city))])]), _vm._v(" "), _c('p', [_vm._v("Delivery Fee: "), _c('b', [_vm._v(_vm._s(items.order_delivery_fee))])])]), _vm._v(" "), (order.order_business_delivery_options.length != 0) ? _c('p', [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.displayDeliveryOptions(order)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-undo"
      }), _vm._v(" Change Delivery Details")])]) : _vm._e(), _vm._v(" "), (_vm.selected_order.order_no == order.order_no) ? _c('div', [(_vm.selected_order.display_delivery) ? _c('div', _vm._l((order.order_business_delivery_options), function(option) {
        return _c('div', [(option.business_delivery_product == items.product_id) ? _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.item_delivery_fee),
            expression: "item_delivery_fee"
          }],
          attrs: {
            "type": "radio"
          },
          domProps: {
            "value": option.business_delivery_option_id,
            "checked": _vm._q(_vm.item_delivery_fee, option.business_delivery_option_id)
          },
          on: {
            "click": function($event) {
              _vm.calc_product_specific_delivery_fee(index, index2, option)
            },
            "__c": function($event) {
              _vm.item_delivery_fee = option.business_delivery_option_id
            }
          }
        }), _vm._v(_vm._s(option.business_delivery_option) + " - " + _vm._s(option.business_delivery_option_price)), _c('br')]) : _vm._e()])
      })) : _vm._e()]) : _vm._e()]) : _vm._e()])
    }), _vm._v(" "), _c('p', [_vm._v("Delivery Address:")]), _vm._v(" "), _c('div', {
      staticClass: "contact-form"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (order.order_user_new_delivery_address),
        expression: "order.order_user_new_delivery_address"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Enter Delivery Address"
      },
      domProps: {
        "value": (order.order_user_new_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          order.order_user_new_delivery_address = $event.target.value
        }
      }
    }, [_vm._v(_vm._s(order.order_user_delivery_address))])]), _vm._v(" "), (order.order_delivery_not_set) ? _c('div', [_c('p', [_c('b', [_vm._v("Delivery Details:  ")]), _vm._v(_vm._s(order.order_delivery_not_set))])]) : _c('div', [_c('p', [_vm._v("Delivery Location: "), _c('b', [_vm._v(_vm._s(order.order_delivery_city))])]), _vm._v(" "), _c('p', [_vm._v("Delivery Fee: "), _c('b', [_vm._v(_vm._s(order.order_delivery_fee))])])]), _vm._v(" "), (order.order_business_delivery_options.length != 0) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.displayDeliveryOptions(order)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-undo"
    }), _vm._v(" Change Delivery Details")])]) : _vm._e(), _vm._v(" "), (_vm.selected_order.order_no == order.order_no) ? _c('div', [(_vm.selected_order.display_delivery) ? _c('div', _vm._l((order.order_business_delivery_options), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (order.delivery_fee),
          expression: "order.delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(order.delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_delivery_fee(index, option)
          },
          "__c": function($event) {
            order.delivery_fee = option.business_delivery_option_id
          }
        }
      }), _vm._v(_vm._s(option.business_delivery_option) + " - " + _vm._s(option.business_delivery_option_price)), _c('br')]) : _vm._e()])
    })) : _vm._e()]) : _vm._e()], 2)])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.processPayment()
      }
    }
  }, [_vm._v("Process Payment")])])]) : _c('div', {
    staticClass: "col-md-8 col-md-offset-2 col-xs-12",
    staticStyle: {
      "text-align": "center",
      "background": "#f1eae4",
      "margin-top": "8em",
      "padding-bottom": "2em"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Checkout "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-frown-o",
    staticStyle: {
      "font-size": "3em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "26px",
      "color": "#000000",
      "line-clamp": "1.4"
    }
  }, [_vm._v("Sorry no items to checkout. Have you selected Items from your "), _c('a', {
    staticStyle: {
      "color": "rgb(197, 49, 74)"
    },
    attrs: {
      "href": "cart"
    }
  }, [_vm._v("Cart?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7034a58"}!./src/pages/Buypoint/Checkout/template.html
// module id = 297
// module chunks = 0